import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["message", "progressBar"];
  static values = { timeout: { type: Number, default: 5 } };

  connect() {
    if (this.timeoutValue > 0) {
      this.duration = this.timeoutValue * 1000;
      this.startTime = performance.now();

      this.rafId = requestAnimationFrame(this.updateProgress.bind(this));

      this.timeoutId = setTimeout(() => {
        this.close();
      }, this.duration);
    }
  }

  updateProgress(timestamp) {
    const elapsed = timestamp - this.startTime;
    const fraction = Math.min(elapsed / this.duration, 1);

    if (this.hasProgressBarTarget) {
      this.progressBarTarget.style.width = `${fraction * 100}%`;
    }

    if (elapsed < this.duration) {
      this.rafId = requestAnimationFrame(this.updateProgress.bind(this));
    }
  }

  close() {
    if (this.hasMessageTarget) {
      this.messageTarget.remove();
    }
    cancelAnimationFrame(this.rafId);
    clearTimeout(this.timeoutId);
  }

  disconnect() {
    cancelAnimationFrame(this.rafId);
    clearTimeout(this.timeoutId);
  }
}
